const getCurrentDate = (): Object => {
  return new Date();
};

const getCurrentDDMMYYDate = (): string => {
  const date: Date = new Date();
  let [month, day, year] = [date.getMonth() + 1, date.getDate(), date.getFullYear()];

  const sMonth: string = month < 10 ? `0${month}` : `${month}`;
  const sDay: string = day < 10 ? `0${day}` : `${day}`;
  return `${sDay}.${sMonth}.${year}`;
};

const formatDate = (value: Date | string): string => {
  if (value === '') return 'Žádné datum';
  const date = new Date(value);
  const [month, day, year] = [date.getMonth() + 1, date.getDate(), date.getFullYear()];
  return `${day}.${month}.${year}`;
};

const parseDate = (data: string): string => {
  const date = new Date(data);
  let [month, day, year] = [date.getMonth() + 1, date.getDate(), date.getFullYear()];
  const newMonth = month < 10 ? `0${month}` : month;
  const newDay = day < 10 ? `0${day}` : day;
  return `${year}-${newMonth}-${newDay}`;
};

/** Formats a Date or ISO string to Czech locale date string — e.g. "20. 3. 2026" */
const formatDateCZ = (value: Date | string): string => {
  if (!value) return '–';
  return new Date(value).toLocaleDateString('cs-CZ');
};

/** Formats a Date or ISO string to HH:MM time string — e.g. "08:30" */
const formatTimeCZ = (value: Date | string): string => {
  if (!value) return '–';
  return new Date(value).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' });
};

/** Formats a Date or ISO string to Czech locale datetime string — e.g. "20. 3. 2026 08:30:00" */
const formatDateTimeCZ = (value: Date | string): string => {
  if (!value) return '–';
  return new Date(value).toLocaleString('cs-CZ');
};

/** Returns today's date as YYYY-MM-DD using local timezone (avoids UTC offset issues) */
const todayISOLocal = (): string => {
  const now = new Date();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${m}-${d}`;
};

/** Converts a Date object to YYYY-MM-DD using local timezone (avoids UTC offset issues) */
const toISOLocal = (date: Date): string => {
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${m}-${d}`;
};

export const dateHelper = {
  getCurrentDate,
  getCurrentDDMMYYDate,
  formatDate,
  parseDate,
  formatDateCZ,
  formatTimeCZ,
  formatDateTimeCZ,
  todayISOLocal,
  toISOLocal,
};
